import { useState, useEffect, useMemo } from "react";
import Form from "../../../Components/Form";
import TabBox from "../../../Components/Tabbox/TabBox";
import {
  IStepAddOrderFormValues,
  IStepOptionDropdownItem,
  IStepOrderPreview,
  StepInstrumentType,
  StepOptionOrderType,
  StepOrderSide,
  StepOrderTypes,
  VolumeCalculationType,
} from "../../../Interfaces/stepInterfaces";
import Button from "../../../Components/Button";
import { useAppDispatch, useAppSelector } from "../../../App/hooks";
import {
  setStepAddOrderFormValues,
  setStepOrderOperationType,
  setStepOrderTableFetchDataFlag,
} from "../../../Features/Step/stepSlice";
import Modal from "../../../Components/Modal/Modal";
import PreviewStepOrderTable from "../../../Tables/Step/PreviewStepOrderTable";
import PreviewVolumeSummaryTable from "../../../Tables/Order/PreviewVolumeSummaryTable";
import PreviewWarningsTable from "../../../Tables/Order/PreviewWarningsTable";
import SahraConnections from "../../Sahra/SahraConnections";
import {
  addStepCompetitionOrder,
  addStepShekarOrder,
  getStepInstruments,
  getPreview,
} from "../../../Requests/stepRequests";
import { toast } from "react-toastify";
import PortfoGroupUserMultiSelectDropdown from "../../../Components/Dropdown/Users/PortfoGroupUserMultiSelectDropdown";
import CustomDynamicDropdown from "../../../Components/Dropdown/CustomDropdown/CustomDynamicDropdown";
import StaticDropdown from "../../../Components/Dropdown/StaticDropdown";
import TextInput from "../../../Components/TextInput";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import { CheckBox, TimePicker } from "src/Components";
import {
  hasInvalidStepOrderTimeRange,
  STEP_ORDER_TIME_RANGE_ERROR,
} from "../stepOrderScheduleValidation";

enum ModalMode {
  SahraUsers,
  OrderPreview,
}

const getTimePickerValue = (value?: string | null) =>
  value ? `${new Date().toISOString().slice(0, 10)}T${value}` : null;

const SingleOrder = () => {
  const formValues = useAppSelector((store) => store.step.addOrderFormValues);
  const operationType = useAppSelector((store) => store.step.operationType);
  const [loading, setLoading] = useState(false);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [instrument, setInstrument] = useState<IStepOptionDropdownItem | null>(
    null,
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState(ModalMode.OrderPreview);
  const [preview, setPreview] = useState<IStepOrderPreview | null>(null);
  const [isImmediate, setIsImmediate] = useState(true);
  const dispatch = useAppDispatch();

  const getBtn = (onClick: () => void) => (
    <Button
      text={`${formValues?.orderSide === StepOrderSide.Buy ? "خرید" : "فروش"}`}
      onClick={onClick}
      variant="contained"
      className={`!mb-2 ${
        !checkDisabled()
          ? formValues?.orderSide === StepOrderSide.Buy
            ? "green-btn"
            : "red-btn"
          : ""
      }`}
      disabled={checkDisabled()}
      loading={loading}
    />
  );

  const instrumentChangeHandler = (
    _: string,
    value: IStepOptionDropdownItem | null,
  ) => {
    dispatch(
      setStepAddOrderFormValues({
        ...formValues,
        instrumentId: value?.id || null,
        instrumentType: value?.type || null,
        optionOrderType: null,
        volumeCalculationType: value?.type === StepInstrumentType.Future
          ? VolumeCalculationType.FixedAmount : formValues?.volumeCalculationType,
      } as IStepAddOrderFormValues),
    );
  };

  useEffect(() => {
    setInstrument({
      id: formValues?.instrumentId || null,
      type: formValues?.instrumentType || null,
    } as IStepOptionDropdownItem);
  }, [formValues?.instrumentId, formValues?.instrumentType]);

  const changeHandler = (
    name: string,
    value: any,
    name2?: string,
    value2?: any,
  ) => {
    if (!name2)
      dispatch(
        setStepAddOrderFormValues({
          ...formValues,
          [name]: value,
        } as IStepAddOrderFormValues),
      );
    else
      dispatch(
        setStepAddOrderFormValues({
          ...formValues,
          [name]: value,
          [name2]: value2,
        } as IStepAddOrderFormValues),
      );
  };

  const checkboxChangeHandler = (name: string, checked: boolean) => {
    changeHandler(name, checked);
  };

  const scheduleTimeChangeHandler = (name: string, timeString: string) => {
    const schedule = {
      ...(formValues?.schedule || {
        startTime: null,
        stopTime: null,
      }),
      [name]: timeString || null,
    };

    changeHandler("schedule", schedule);
  };

  const checkDisabled = () => {
    if (!formValues) return true;
    if (
      !formValues.instrumentId ||
      !formValues.orderSide ||
      !formValues.stepCount ||
      !formValues.fromPrice ||
      !formValues.toPrice ||
      !formValues.userIds ||
      !formValues.userIds.length ||
      !formValues.volume
    )
      return true;

    if (operationType !== StepOrderTypes.Competition && !formValues.blockSize)
      return true;

    //  if (formValues.instrumentType === StepInstrumentType.Fund)
    //    if (!formValues.navBubblePercent) return true;

    if (formValues.instrumentType === StepInstrumentType.Option ||
        formValues.instrumentType === StepInstrumentType.Future)
      if (!formValues.optionOrderType) return true;
    return false;
  };

  const getOrderSideChildren = () => [
    {
      index: 1,
      title: "خرید",
      value: StepOrderSide.Buy,
      className:
        formValues?.orderSide === StepOrderSide.Buy
          ? "!border-2 !border-green-600 !text-white hover:!border-green-700 !bg-green-600 hover:!bg-green-700 "
          : "!border-2 !border-gray-300 !text-gray-300 hover:!border-gray-400 hover:!text-gray-400",
    },
    {
      index: 2,
      title: "فروش",
      value: StepOrderSide.Sell,
      className:
        formValues?.orderSide === StepOrderSide.Sell
          ? "!border-2 !border-red-700 !text-white hover:!border-red-800 !bg-red-700 hover:!bg-red-800"
          : "!border-2 !border-gray-300 !text-gray-300 hover:!border-gray-400 hover:!text-gray-400",
    },
  ];

  const getProperFunction = (values: IStepAddOrderFormValues) => {
    switch (operationType) {
      case StepOrderTypes.Hunt:
        return addStepShekarOrder(values);

      case StepOrderTypes.Competition:
        return addStepCompetitionOrder(values);
    }
  };

  const sahraUsersModalBtnClickHandler = () => {
    if (!preview) return;
    const orderDto = getExecutablePreviewOrderDto();
    if (!orderDto) {
      toast.error("هیچ سفارشی با حجم معتبر وجود ندارد.");
      return;
    }
    if (
      hasInvalidStepOrderTimeRange(
        orderDto.schedule,
        orderDto.startImmediately,
      )
    ) {
      toast.error(STEP_ORDER_TIME_RANGE_ERROR);
      return;
    }

    setLoading(true);
    getProperFunction(orderDto as unknown as IStepAddOrderFormValues)
      .then((resp) => {
        if (!resp.data) toast.error(resp.msg);
        else {
          toast.success(resp.msg);
          setIsModalOpen(false);
          dispatch(setStepOrderTableFetchDataFlag(true));
          dispatch(
            setStepAddOrderFormValues({
              instrumentId: preview.orderDto.instrumentId,
              optionOrderType: preview.orderDto.optionOrderType,
              orderSide: preview.orderDto.orderSide,
              instrumentType: preview.orderDto.instrumentType,
            } as IStepAddOrderFormValues),
          );
          setIsImmediate(true);
        }
      })
      .catch(packetErrorHandler)
      .finally(() => {
        setLoading(false);
      });
  };

  const getExecutablePreviewRows = () =>
    (preview?.rows || []).filter((row) => row.totalVolume > 0);

  // Rows with no previewStatus were successfully read (even if the calculated volume is
  // legitimately zero) and belong in the main preview grid. Rows with a previewStatus
  // (Timeout/BrokenOrder/NoConnectedUser/Offline/Deduplicated) could not produce a real
  // order and are surfaced only in the warning table below.
  const getDisplayPreviewRows = () =>
    (preview?.rows || []).filter((row) => !row.previewStatus);

  const getExecutablePreviewOrderDto = () => {
    if (!preview) return null;

    const executableRows = getExecutablePreviewRows();
    const failedRows = (preview.rows || []).filter((row) => row.previewStatus);
    // Nothing executable AND nothing to log as failed either - genuinely nothing to send.
    if (!executableRows.length && !failedRows.length) return null;

    const executableUserIds = executableRows.map((row) => row.userId);
    const executableUserIdSet = new Set(executableUserIds);
    const executableVolumePerUser = Object.fromEntries(
      Object.entries(preview.orderDto.volumePerUser || {}).filter(([key]) =>
        executableUserIdSet.has(Number(key)),
      ),
    ) as Record<string, number>;

    return {
      ...preview.orderDto,
      userIds: executableUserIds,
      volumePerUser: executableVolumePerUser,
      failedRows,
    };
  };

  const removePreviewRowHandler = (userId: number) => {
    setPreview((current) => {
      if (!current) return current;

      const removedRow = current.rows.find((row) => row.userId === userId);
      const nextRows = current.rows.filter((row) => row.userId !== userId);
      const nextUserIds = current.orderDto.userIds.filter(
        (id) => id !== userId,
      );
      const nextTimedOutUserIds = (current.timedOutUserIds || []).filter(
        (id) => id !== userId,
      );
      const nextBrokenOrderUserIds = (current.brokenOrderUserIds || []).filter(
        (id) => id !== userId,
      );
      const nextVolumePerUser = Object.fromEntries(
        Object.entries(current.orderDto.volumePerUser || {}).filter(
          ([key]) => Number(key) !== Number(userId),
        ),
      ) as Record<string, number>;

      // The removed row only ever contributed to volumeSummary if it was executable
      // (no previewStatus and totalVolume > 0) - subtract its volume and engaged capital from that group.
      const nextVolumeSummary =
        removedRow && !removedRow.previewStatus && removedRow.totalVolume > 0
          ? (current.volumeSummary || [])
              .map((item) =>
                item.orderSide === removedRow.orderSide &&
                item.instrumentId === removedRow.instrumentId
                  ? {
                      ...item,
                      totalVolume: item.totalVolume - removedRow.totalVolume,
                      engagedCapitalAmount:
                        item.engagedCapitalAmount - removedRow.engagedCapitalAmount,
                    }
                  : item,
              )
              .filter((item) => item.totalVolume > 0)
          : current.volumeSummary;

      return {
        ...current,
        rows: nextRows,
        timedOutUserIds: nextTimedOutUserIds,
        brokenOrderUserIds: nextBrokenOrderUserIds,
        volumeSummary: nextVolumeSummary,
        orderDto: {
          ...current.orderDto,
          userIds: nextUserIds,
          volumePerUser: nextVolumePerUser,
        },
      };
    });
  };

  const getOrderSideActiveTab = () => {
    if (formValues?.orderSide === StepOrderSide.Buy) return 1;
    return 2;
  };

  const getPreviewWarningRowsForTable = () =>
    (preview?.rows || []).flatMap((row) => {
      const userName = row.userName || row.userId.toString();

      if (!row.previewStatus) return [];

      return [{ userName, message: row.previewMessage || "هشدار پیش‌نمایش سفارش" }];
    });

  const getSahraUserTable = () => {
    return (
      <div className="flex flex-col justify-start items-center gap-3">
        <SahraConnections
          initialSearchParam={{
            userIds:
              getExecutablePreviewOrderDto()?.userIds ||
              formValues?.userIds ||
              [],
          }}
        />

        {getBtn(sahraUsersModalBtnClickHandler)}
      </div>
    );
  };

  const getOrderPreviewTable = () => (
    <div className="flex flex-col justify-start items-center gap-10">
      <PreviewVolumeSummaryTable
        values={preview?.volumeSummary}
        editableCompetitionSettings={operationType === StepOrderTypes.Competition}
      />
      {/* autoSellFund={!!formValues?.autoSellFund} */}
      <PreviewStepOrderTable 
      values={getDisplayPreviewRows()} 
      loading={previewLoading}
      onRemoveRow={removePreviewRowHandler}
      />
      {/* <CheckBox
        checked={!!formValues?.autoSellFund}
        label="فروش خودکار صندوق درآمد ثابت"
        name="autoSellFund"
        onChange={checkboxChangeHandler}
        disabled
      /> */}
      {getBtn(() => {
        setModalMode(ModalMode.SahraUsers);
      })}
      <PreviewWarningsTable rows={getPreviewWarningRowsForTable()} />
    </div>
  );

  const getModalUI = () => {
    switch (modalMode) {
      case ModalMode.SahraUsers:
        return getSahraUserTable();

      case ModalMode.OrderPreview:
        return getOrderPreviewTable();
    }
  };

  const modalCloseHandler = () => {
    switch (modalMode) {
      case ModalMode.OrderPreview: {
        setIsModalOpen(false);
        break;
      }
      case ModalMode.SahraUsers: {
        setModalMode(ModalMode.OrderPreview);
        break;
      }
      default:
        break;
    }
  };

  const volumeCalculationTypeOptions = [
    { id: VolumeCalculationType.FixedAmount, name: "مقدار ثابت" },
    {
      id: VolumeCalculationType.PortfolioPercent,
      name: "% از پورتفو",
    },
    {
      id: VolumeCalculationType.AssetPercent,
      name: "% از دارایی",
    },
    {
      id: VolumeCalculationType.TargetPortfolioPercent,
      name: "% هدف از پورتفو",
    },
    {
      id: VolumeCalculationType.BuyingPowerPercent,
      name: "% از قدرت خرید",
    },
    {
      id: VolumeCalculationType.FixedCapitalAmount,
      name: "سرمایه درگیر (مبلغ) ثابت",
    },
  ];

  const volume = useMemo(
    () =>
      volumeCalculationTypeOptions.find(
        (item) => item.id === formValues?.volumeCalculationType,
      )?.name ?? "حجم",
    [formValues?.volumeCalculationType],
  );

  return (
    <Form>
      <div className="w-80">
        {isModalOpen ? (
          <Modal title="ثبت سفارش" onClose={modalCloseHandler} UI={getModalUI()} />
        ) : null}
        <div className="flex flex-col justify-start items-center w-full px-2 gap-3 mt-3">
          <StaticDropdown
            options={[
              { id: StepOrderTypes.Hunt, name: "شکار" },
              { id: StepOrderTypes.Competition, name: "کمین" },
            ]}
            value={operationType}
            onChange={(_, value) => dispatch(setStepOrderOperationType(value))}
            dropdown={{
              name: "operationType",
              placeholder: "نوع عملیات",
              extraLabel: true,
            }}
          />
          <PortfoGroupUserMultiSelectDropdown
            extraLabel
            name="userIds"
            label="نام اکانت ها"
            // className: "mt-3",
            onChange={changeHandler}
            value={formValues?.userIds}
            withTagBox
          />
          <div className="flex flex-row justify-start items-center gap-5 w-full">
            <TabBox
              children={getOrderSideChildren()}
              activeTab={getOrderSideActiveTab()}
              onChange={(name, _, value) => changeHandler(name, value)}
              name="orderSide"
            />
          </div>
          <CustomDynamicDropdown
            dropdown={{
              name: "instrumentId",
              placeholder: "نماد",
              extraLabel: true,
            }}
            onChange={instrumentChangeHandler}
            getData={getStepInstruments}
            value={instrument}
          />
          {(formValues?.instrumentType === StepInstrumentType.Option ||
            formValues?.instrumentType === StepInstrumentType.Future) ? (
            <StaticDropdown
              dropdown={{
                name: "optionOrderType",
                placeholder: formValues?.instrumentType === StepInstrumentType.Future
                  ? "نوع معامله آتی" : "نوع معامله اختیار",
                extraLabel: true,
              }}
              onChange={changeHandler}
              options={[
                {
                  id: StepOptionOrderType.Offset,
                  name: "Offset",
                },
                {
                  id: StepOptionOrderType.Open,
                  name: "Open",
                },
              ]}
              value={formValues?.optionOrderType}
            />
          ) : null}

          <div className="flex flex-row justify-start items-center gap-3">
            <TextInput
              label="ابتدای بازه"
              name="fromPrice"
              onChange={changeHandler}
              value={formValues?.fromPrice?.toString()}
              kind="price"
              extraLabel
            />
            <TextInput
              label="انتهای بازه"
              name="toPrice"
              onChange={changeHandler}
              value={formValues?.toPrice?.toString()}
              kind="price"
              extraLabel
            />
          </div>
          <TextInput
            label="تعداد پلکان"
            name="stepCount"
            onChange={changeHandler}
            value={formValues?.stepCount?.toString()}
            kind="price"
            extraLabel
          />

          <StaticDropdown
            dropdown={{
              name: "volumeCalculationType",
              placeholder: "روش تعیین حجم",
              extraLabel: true,
            }}
            onChange={changeHandler}
            value={formValues?.volumeCalculationType}
            options={formValues?.instrumentType === StepInstrumentType.Future
              ? volumeCalculationTypeOptions.filter(item => item.id === VolumeCalculationType.FixedAmount)
              : volumeCalculationTypeOptions}
          />

          <TextInput
            label={volume}
            name="volume"
            onChange={changeHandler}
            value={formValues?.volume?.toString()}
            kind="priceWithDecimal"
            extraLabel
          />
          {operationType !== StepOrderTypes.Competition ? (
            <TextInput
              label="حجم هر بلوک به صورت درصدی"
              name="blockSize"
              onChange={changeHandler}
              value={formValues?.blockSize?.toString()}
              kind="percent"
              extraLabel
            />
          ) : null}
          <div className="flex flex-col justify-start items-start gap-3 w-full">
            <div className="flex w-full justify-start">
              <CheckBox
                checked={!!formValues?.autoSellFund}
                label="فروش خودکار صندوق درآمد ثابت"
                name="autoSellFund"
                onChange={checkboxChangeHandler}
              />
            </div>
            <div className="flex w-full justify-start">
              <CheckBox
                checked={isImmediate}
                label="شروع آنی"
                name="isImmediate"
                onChange={(_, checked) => {
                  setIsImmediate(checked);
                  changeHandler(
                    "schedule",
                    checked
                      ? null
                      : formValues?.schedule || {
                          startTime: null,
                          stopTime: null,
                        },
                  );
                }}
              />
            </div>
          </div>
          {!isImmediate ? (
            <div className="grid grid-cols-2 gap-3 w-full rounded-lg border border-slate-200 p-3">
              <div className="flex w-full flex-col gap-1">
                <TimePicker
                  name="startTime"
                  placeholder="زمان شروع"
                  value={getTimePickerValue(formValues?.schedule?.startTime)}
                  onChange={(name, value) =>
                    scheduleTimeChangeHandler(name, value.timeString)
                  }
                  extraLabel
                  minimumHour={8}
                  needConfirm={false}
                  showColumnLabels
                />
              </div>
              <TimePicker
                name="stopTime"
                placeholder="زمان توقف"
                value={getTimePickerValue(formValues?.schedule?.stopTime)}
                onChange={(name, value) =>
                  scheduleTimeChangeHandler(name, value.timeString)
                }
                extraLabel
                minimumHour={8}
                needConfirm={false}
                showColumnLabels
              />
            </div>
          ) : null}
          {/* {formValues?.instrumentType === StepInstrumentType.Fund ? (
            <TextInput
            label="درصد حباب NAV"
            name="navBubblePercent"
            onChange={changeHandler}
            value={formValues?.navBubblePercent?.toString()}
            kind="percent"
            />
            ) : null} */}
          {getBtn(() => {
            if (
              hasInvalidStepOrderTimeRange(formValues?.schedule, isImmediate)
            ) {
              toast.error(STEP_ORDER_TIME_RANGE_ERROR);
              return;
            }

            setIsModalOpen(true);
            setModalMode(ModalMode.OrderPreview);
            setPreview(null);
            setPreviewLoading(true);
            getPreview({
              ...(formValues as IStepAddOrderFormValues),
              startImmediately: isImmediate,
              orderStartegyStr:
                operationType === StepOrderTypes.Hunt ? "شکار" : "کمین",
            })
              .then((pre) => setPreview(pre))
              .catch(packetErrorHandler)
              .finally(() => setPreviewLoading(false));
          })}
        </div>
      </div>
    </Form>
  );
};

export default SingleOrder;
